module.exports = __webpack_public_path__ + "static/w-ajeng-ef501ef58df3ab435ec5ffb0c8231c22.jpeg";